module.exports = __webpack_public_path__ + "img/copy.38e4b708.svg";